import * as Yup from "yup";

export const ValidationChangePassword = Yup.object().shape({
  new_password: Yup.string()
    .required("Campo obrigatório")
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z 0-9])(?=.{8,})/,
      "A senha deve possuir todos os requisitos"
    ),
  new_password_confirmation: Yup.string()
    .required("Campo obrigatório")
    .oneOf([Yup.ref("new_password")], "Senhas diferentes"),
});
